import moment from 'moment'
import Vue from 'vue'

const formatDateDMY = date => {
  return moment(date).format('DD.MM.YYYY')
}

const formatDateWithMonthName = date => {
  return moment(date).format('MMMM DD, YYYY')
}

const formatMonDYYYY = date => {
  return moment(date).format('MMM, DD YYYY')
}

Vue.filter('mmmddYYYY', formatMonDYYYY)
Vue.filter('ddmmYYYY', formatDateDMY)
Vue.filter('monthDDYY', formatDateWithMonthName)
